// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client_" + {"114":"pages-stores","288":"Search","350":"CategorySearch","363":"pages-cart","570":"pages-order-confirmation","607":"pages-compare-products","957":"PDP"}[chunkId] + ".css";
};